
import { defineComponent, ref } from 'vue';

import StoreLinks from '../StoreLinks.vue';

import IPhoneHomeScreenDark from '../../assets/iphone-home-screen-dark.png';
import IPhoneHomeScreenLight from '../../assets/iphone-home-screen-light.png';
import MacHomeScreenDark from '../../assets/mac-home-screen-dark.png';
import MacHomeScreenLight from '../../assets/mac-home-screen-light.png';

const darkModeMatch = matchMedia('(prefers-color-scheme: dark)');
const isDarkMode = ref(darkModeMatch.matches);

darkModeMatch.addEventListener('change', ({ matches }) => {
	if (isDarkMode.value === matches) return;
	isDarkMode.value = matches;
});

const assets = {
	dark: {
		iPhoneHomeScreen: IPhoneHomeScreenDark,
		macHomeScreen: MacHomeScreenDark,
	},
	light: {
		iPhoneHomeScreen: IPhoneHomeScreenLight,
		macHomeScreen: MacHomeScreenLight,
	},
};

function getCurrentAssets() {
	if (isDarkMode.value) return assets.dark;
	return assets.light;
}

function iPhoneHomeScreenSource() {
	return getCurrentAssets().iPhoneHomeScreen;
}

function macHomeScreenSource() {
	return getCurrentAssets().macHomeScreen;
}

export default defineComponent({
	data: () => ({
		isDarkMode,
	}),
	computed: {
		iPhoneHomeScreenSource,
		macHomeScreenSource,
	},
	components: {
		StoreLinks,
	},
	name: 'HomeContent',
});
